import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

import TabPanel from '../../components/TabPanel';
import Overview from '../../pages/issuer/Trade/Overview';
import History from '../../pages/issuer/Trade/History';

import VerticalContainer from '../../components/VerticalContainer';

const TradeRoutes = () => {
    let { path } = useRouteMatch();

    return (
        <VerticalContainer>
            <TabPanel>
                <Switch>
                    <Route exact path={`${path}`} component={Overview} />
                    <Route exact path={`${path}/history`} component={History} />
                </Switch>
            </TabPanel>
        </VerticalContainer>
    );
};

export default TradeRoutes;
